import { combineReducers } from "redux";

import registrationReducer, {
  initialState as initialRegistrationState
} from "@tvg/rma/src/reducer";

import { CapiState, RegistrationState } from "./types";

import capiReducer, {
  initialState as initialCapiState
} from "./App/capiReducer";

export type AppState = {
  capi: CapiState;
  registration: RegistrationState;
};

export type RootState = ReturnType<typeof rootReducer>;

export const initialState = {
  capi: initialCapiState,
  registration: initialRegistrationState
} as AppState;

const rootReducer = combineReducers({
  capi: capiReducer,
  registration: registrationReducer
});

export default rootReducer;
